/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

import Vue from "vue";
import { IErrorHandler } from "./IErrorHandler";

/**
 * Error handler that is called when an error occurs in the axios request and console logs stuff.
 */
export class LogAxiosErrorHandler implements IErrorHandler {
  handle(error: any): any {
    Vue.$log.error(error);

    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      Vue.$log.info(error.response.status);
      Vue.$log.info(error.response.data);
      Vue.$log.info(error.response.headers);
    } else if (error.request) {
      // The request was made but no response was received `error.request` is an instance of XMLHttpRequest in the browser
      Vue.$log.info(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      Vue.$log.info("Error", error.message);
    }
  }
}
